import { render, staticRenderFns } from "./PaymentMethodTitle.vue?vue&type=template&id=47e2b90f&"
import script from "./PaymentMethodTitle.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodTitle.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodTitle.vue?vue&type=style&index=0&module=true&lang=postcss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports